export default {
    name: 'HowItWorksMiniCard',
    props: {
        cardTitle: {
            type: String,
            required: true
        },
        imageLink: {
            type: String,
            required: true
        }
    }
}